import styled from "styled-components";
import {LobbyWrapperDefaultBox} from "./lobby-wrapper.default.box";

export const LobbyWrapperSIBox = styled(LobbyWrapperDefaultBox)`
  &:before {
    background-image: none;
  }
`